<script setup>
import UnderwritingMainTable from '@/views/Underwriting/TableView/components/UnderwritingMainTable.vue';
import ChangeHierarchyOrderModal from '@/views/Underwriting/TableView/components/ChangeHierarchyOrderModal.vue';
import UnderwritingControllerModal from '@/views/Underwriting/TableView/components/UnderwritingControllerModal.vue';
import { useUnderwritingStore } from '@/stores/underwriting';
import AddNewBusinessModal from './components/AddNewBusinessModal.vue';

const underwritingStore = useUnderwritingStore();
</script>

<template>
  <ChangeHierarchyOrderModal v-if="underwritingStore.isChangeHierarchyOrderModal" />
  <UnderwritingControllerModal v-if="underwritingStore.isUnderwritingControllerModal" />
  <AddNewBusinessModal v-if="underwritingStore.isNewBusinessModal" />
  <div class="shadow-md">
    <UnderwritingMainTable />
  </div>
</template>
